module.exports = __webpack_public_path__ + "static/media/toolsPublish.a242bb8e.svg";